import cx from "classnames";
import { BigInfoIcon, Flex, Spinner } from "@theorgchartdev/storybook";
import { useFetchSubmissions } from "./useFetchSubmissions";
import { appstr } from "@coreapp/utils/appstr";
import { SubmissionSummary } from "./SubmissionSummary";

type ApprovalsTabProps = {};

export const ApprovalsTab = (props: ApprovalsTabProps) => {
  const { planSubmissions, isLoading } = useFetchSubmissions();

  if (isLoading) {
    return (
      <Flex padding={"16px"} justifyContent="center" alignItems="center" height="100%">
        <Spinner />
      </Flex>
    );
  }

  return (
    <Flex className={cx("oc-fill-height", "ocn-list-scrollbar")} overflow="auto">
      <Flex direction="column" gap="16px" padding="16px" height="fit-content" width="100%">
        {planSubmissions.length === 0 ? (
          <BigInfoIcon
            name="file-check"
            message={appstr("No plan approvals have been made yet.")}
            color="brand"
          />
        ) : (
          planSubmissions.map((submission, index) => (
            <SubmissionSummary
              key={index}
              submission={submission}
              title={`Submission #${planSubmissions.length - index}`}
            />
          ))
        )}
      </Flex>
    </Flex>
  );
};
